export function humanize(str?: string) {
  if (!str) return null;

  const newStr = str.replace(/_/g, ' ');
  return newStr[0].toUpperCase() + newStr.substring(1);
}

export default humanize;
